"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  var placeholder = {
    fontStyle: 'italic',
    color: theme['$placeholder-color']
  };
  return {
    TextArea: {
      boxSizing: 'border-box',
      height: 96,
      border: 'none',
      outline: 'none',
      padding: [9, 12],
      borderRadius: 6,
      fontFamily: theme['$font-default'],
      fontSize: 12,
      lineHeight: 'initial',
      background: theme['$input-background'],
      color: theme['$text-color'],
      '&::placeholder': placeholder,
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      '&:placeholder': placeholder,
      '&:-ms-input-placeholder': placeholder,
      '&:-moz-placeholder': placeholder,
      resize: 'none'
    },
    Light: {
      backgroundColor: theme['$input-background-light']
    },
    Disabled: {
      opacity: 0.3
    },
    Error: {
      background: theme['$input-background-error']
    },
    Warning: {
      background: theme['$input-background-warning']
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map